//import {forEach} from "lodash";

export class Query {
    mls_agent_id = null;
    limit = 20;
    page = 1;
    featured = true;
    ne_lat = 44.05596804434469;
    ne_lng = -70.05981445312501;
    sw_lat = 34.651235232535754;
    sw_lng = -84.56176757812501;
    show_full_total = false;
    only_active = false;

    filter = {
      deal_type: null,
      property_type: null,
      address: null,
      price:{
        min: null,
        max: null
      },
      bedroom: {
        min: null,
        max: null
      },
      bathroom: {
        min: null,
        max: null
      },
      square: {
        min: null,
        max: null
      },
    }
    // fields = {}
  // geo_hash
  geo_hash = false;
  zoom = null;
  precision = null;
  city = null;
  place_id = null;
  place_type = null;

    initBaseConfig() {
      this.limit = 20;
      // ne_lat=44.05596804434469&ne_lng=-70.05981445312501&sw_lat=34.651235232535754&sw_lng=-84.56176757812501
      this.ne_lat = 44.05596804434469;
      this.ne_lng =-70.05981445312501;
      this.sw_lat = 34.651235232535754;
      this.sw_lng =-84.56176757812501;
    }
    initBaseFilters() {
      this.filter = {
        deal_type: null,
        property_type: null,
        address: null,
        price:{
          min: null,
          max: null
        },
        bedroom: {
          min: null,
          max: null
        },
        bathroom: {
          min: null,
          max: null
        },
        square: {
          min: null,
          max: null
        }
      }
    }
    getPayload() {
        let params = {
            "limit" : this.limit,
            "page": this.page,
            // "fields": {}
        }
        if(this.ne_lat) { params.ne_lat = this.ne_lat; }
        if(this.ne_lng) { params.ne_lng = this.ne_lng; }
        if(this.sw_lat) { params.sw_lat = this.sw_lat; }
        if(this.sw_lng) { params.sw_lng = this.sw_lng; }
        if(this.geo_hash) { params.geo_hash = this.geo_hash; }
        if(this.zoom) { params.zoom = this.zoom; }
        if(this.precision) { params.precision = this.precision; }

        if(this.only_active) { params.only_active = this.only_active; }
        if(this.show_full_total) { params.show_full_total = this.show_full_total; }
        if(this.featured) { params.featured = this.featured; }
        if(this.mls_agent_id) { params.mls_agent_id = this.mls_agent_id; }

        if(this.filter.deal_type) { params.deal_type = this.filter.deal_type; }
        if(this.filter.property_type) { params.property_type = this.filter.property_type; }
        if(this.filter.address) { params.address = this.filter.address; }
      if(this.place_id) { params.place_id = this.place_id; }
      if(this.place_type) { params.place_type = this.place_type; }
      if(this.filter.price.min) { params.min = this.filter.price.min; }
      if(this.filter.price.max) { params.max = this.filter.price.max; }

      if(this.filter.bedroom.min) { params.bn = this.filter.bedroom.min; }
      if(this.filter.bedroom.max) { params.bx = this.filter.bedroom.max; }
      if(this.filter.bathroom.min) { params.btn = this.filter.bathroom.min; }
      if(this.filter.bathroom.max) { params.btx = this.filter.bathroom.max; }
      if(this.filter.square.min) { params.sn = this.filter.square.min; }
      if(this.filter.square.max) { params.sx = this.filter.square.max; }


        // forEach(this.fields, (value, field) => {
        //     params['fields'][field] = value;
        // });
        return params;
    }
    toString() {
      return Object.keys(this.getPayload()).map(key => key + '=' + this.getPayload()[key]).join('&');
    }
    initDefaultBounds() {
      this.ne_lat = 44.05596804434469;
      this.ne_lng = -70.05981445312501;
      this.sw_lat = 34.651235232535754;
      this.sw_lng = -84.56176757812501;
    }
    fromString(value) {

      this.mls_agent_id = null;
      this.limit = 20;
      this.page = 1;
      this.initDefaultBounds();
      this.show_full_total = false;
      this.only_active = false;
      //this.featured = false;

      this.initBaseFilters();

      this.geo_hash = false;
      this.zoom = null;
      this.precision = null;
      this.place_id = null;
      this.place_type = null;

      let params = new URLSearchParams(value.replace('#', ''));
      if(params.get('ne_lat')) { this.ne_lat = params.get('ne_lat') }
      if(params.get('ne_lng')) { this.ne_lng = params.get('ne_lng') }
      if(params.get('sw_lat')) { this.sw_lat = params.get('sw_lat') }
      if(params.get('sw_lng')) { this.sw_lng = params.get('sw_lng') }
      if(params.get('geo_hash')) { this.geo_hash = params.get('geo_hash') }
      if(params.get('zoom')) { this.zoom = params.get('zoom') }
      if(params.get('only_active')) { this.only_active = params.get('only_active') }
      if(params.get('show_full_total')) { this.show_full_total = params.get('show_full_total') }
      if(params.get('featured')) { this.featured = params.get('featured') }
      if(params.get('mls_agent_id')) { this.mls_agent_id = params.get('mls_agent_id') }
      if(params.get('deal_type')) { this.filter.deal_type = params.get('deal_type') }
      if(params.get('property_type')) { this.filter.property_type = params.get('property_type') }
      if(params.get('address')) { this.filter.address = params.get('address') }
      if(params.get('limit')) { this.limit = parseInt(params.get('limit')) }
      if(params.get('page')) { this.page = parseInt(params.get('page')) }
      if(params.get('place_id')) { this.place_id = parseInt(params.get('place_id')) }
      if(params.get('place_type')) { this.place_type = params.get('place_type') }
      if(params.get('min')) { this.filter.price.min = params.get('min') }
      if(params.get('max')) { this.filter.price.max = params.get('max') }
      if(params.get('bn')) { this.filter.bedroom.min = params.get('bn') }
      if(params.get('bx')) { this.filter.bedroom.max = params.get('bx') }
      if(params.get('btn')) { this.filter.bathroom.min = params.get('btn') }
      if(params.get('btx')) { this.filter.bathroom.max = params.get('btx') }
      if(params.get('sn')) { this.filter.square.min = params.get('sn') }
      if(params.get('sx')) { this.filter.square.max = params.get('sx') }
    }

    addMatch(field, value) {
        this.fields[field] = value;
    }
    removeMatch(field) {
        delete this.fields[field];
    }


    clone() {
      const query = new Query();
      query.fromString(this.toString());
      return query;
    }
    cloneSaveGeo(oldQuery) {
      const query = new Query();
      query.fromString(this.toString());
      query.sw_lat = oldQuery.sw_lat;
      query.sw_lng = oldQuery.sw_lng;
      query.ne_lat = oldQuery.ne_lat;
      query.ne_lng = oldQuery.ne_lng;
      query.geo_hash = oldQuery.geo_hash;
      query.zoom = oldQuery.zoom;
      return query;
    }
}
